/* Copyright (c) 2020-present CloudIO Inc */

import {
  DefaultExpressionValue,
  ExpressionOnlyValue,
  ExpressionValue,
  Manager,
  PropertyDefinitions,
} from '../../../../registry/Component.type';

export interface BaseCommonProps {
  comments?: string;
}

export interface Responsive {
  xl?: boolean;
  lg?: boolean;
  md?: boolean;
  sm?: boolean;
  xs?: boolean;
}

export interface CommonProps extends BaseCommonProps {
  responsive?: Responsive;
  visible?: boolean;
  visibleCondition?: ExpressionOnlyValue;
  cssClassName?: ExpressionValue;
}

export interface BaseTriggerProps extends BaseCommonProps {
  triggerOnTab?: boolean;
  disableCondition?: ExpressionOnlyValue;
}

export const defaultBaseCommonProps: Required<BaseCommonProps> = {
  comments: '',
};

export const defaultCommonProps: Required<CommonProps> = {
  ...defaultBaseCommonProps,
  responsive: {
    xl: false,
    lg: false,
    md: false,
    sm: false,
    xs: false,
  },
  visible: true,
  visibleCondition: '',
  cssClassName: DefaultExpressionValue,
};

export const defaultActionProps: Required<BaseTriggerProps> = {
  ...defaultBaseCommonProps,
  triggerOnTab: false,
  disableCondition: '',
};

export interface BaseActionProps extends BaseCommonProps {
  disableCondition?: ExpressionOnlyValue;
}
export const defaultTriggerProps: Required<BaseTriggerProps> = {
  ...defaultActionProps,
};

export const ItemIdProp: PropertyDefinitions<{ itemId: string }> = {
  itemId: {
    label: 'Item ID',
    type: 'string',
    category: 'Common',
    required: true,
    preventMultiEdit: true,
  },
};

export const baseCommonProps: PropertyDefinitions<BaseCommonProps> = {
  comments: {
    label: 'Comments',
    type: 'string',
    category: 'Common',
    multiline: true,
  },
};

export const commonProps: PropertyDefinitions<CommonProps> = {
  visible: { label: 'Visible', type: 'boolean', category: 'Common' },
  visibleCondition: {
    label: 'Visible Condition',
    type: 'expressionOnly',
    returnType: () => 'boolean',
    category: 'Common',
    helpText: 'Specify a visible condition',
  },
  cssClassName: {
    label: 'CSS Class Name',
    type: 'expression',
    returnType: async () => 'string',
    category: 'Common',
  },
  responsive: { label: 'Responsive', type: 'responsive', category: 'Common' },
  ...baseCommonProps,
};

export function getDefaultValues<T>(mgr: Manager, property: string): T {
  return mgr.defaultValue[property] as T;
}
